var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountains1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 195,
    viewBox: "0 0 701 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M591.924 193.989C591.924 193.989 668.314 202.515 692.631 170.26C724.18 128.413 659.364 96.6844 609.654 102.595C501.334 115.477 502.686 -74.7815 355.89 33.4264C317.052 62.0499 264.706 10.7077 201.329 74.0788C186.518 88.8909 95.997 60.2675 50.947 71.9851C-37.2196 94.9229 3.09412 194.376 66.0919 194.766C129.09 195.156 591.924 193.989 591.924 193.989Z",
    fill: "#E4E6EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1694 103.613C91.691 101.173 92.6593 98.8719 94.0172 96.8439C95.3751 94.816 97.0951 93.1029 99.0755 91.8058C101.056 90.5086 103.257 89.6537 105.548 89.2915C107.839 88.9293 110.174 89.0672 112.415 89.6971C115.028 83.6607 119.575 78.8516 125.214 76.1588C130.852 73.466 137.202 73.0716 143.089 75.0485C146.152 69.5556 150.591 65.1123 155.891 62.2325C161.192 59.3527 167.138 58.1541 173.042 58.7751C178.946 59.3961 184.567 61.8114 189.255 65.7417C193.943 69.6721 197.507 74.957 199.533 80.9853C202.815 79.0116 206.516 77.9988 210.27 78.0473C214.025 78.0958 217.703 79.204 220.939 81.2619C224.176 83.3199 226.86 86.2563 228.724 89.7805C230.589 93.3046 231.569 97.2942 231.569 101.354C231.569 102.117 231.533 102.872 231.467 103.615L91.1694 103.613Z",
    fill: "#F7F9FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains1);
export default __webpack_public_path__ + "static/media/mountains-1.520341aac8b079ed84c95d5b15e28e2d.svg";
export { ForwardRef as ReactComponent };